import React, { useEffect, useState } from 'react'
import { Drawer } from 'rsuite';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import AccordionMunu from './AccordionMunu';
import { MultiSelect } from 'react-multi-select-component'
import { DropArrow, FilterIcon, SearchIcon,AlertListViewActive, LeftArrowWhite } from '../../assets/images'
import MainOrg from './OrgLevel/MainOrg';
import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom';
import { DASHBOARDCONFIG } from '../../navigation/CONSTANTS';
import { getAlertsData, getDeviceStatusData } from '../../services/dashboardService';
import { DASHBOARD_INTERVAL_TIMER } from '../../config';

const getcsvFileName = (param1, param2) =>{
    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, '0');
    const dd = String(today.getDate()).padStart(2, '0');
    const csvFileName = `${param1.toLowerCase()}_${param2.toLowerCase()}_data_${yyyy}-${mm}-${dd}`;

    return csvFileName
}

const DashboardConfigMain = ({ isDarkTheme,setSelectedTab, handleModalShow}) => {
    const [open, setOpen] = useState(false);
    const [widgetList, setWidgetList] = useState([]);
    const location = useLocation();
    const SiteName = location.state?.SiteName || "Unknown";
    const siteId = location.state?.siteId || '';
    const clientName = location.state?.clientName || "Unknown";
    const ClientId = location.state?.ClientId || "";

    const [deviceStatusPayload, setDeviceStatusPayload] = useState(null);
    const [deviceStatus, setDeviceStatus] = useState(null);
    const [alertsData, setAlertsData] = useState(null);
    const history = useHistory();
    setSelectedTab("dashboard")

    const user = JSON.parse(localStorage.getItem("user"));
    const UserID = user?.Id;

    const fetchDeviceStatusData = (globalFilter = {}) => {
        const payload = [{"WidgetID": 10, "WidgetType": "MultiKPI","Datapoints": {"Interfacetypename": ["ACS"]}},
            {"WidgetID": 11,"WidgetType": "MultiKPI","Datapoints": {"Interfacetypename": ["CCTV"]}},
            {"WidgetID": 12,"WidgetType": "MultiKPI","Datapoints": {"Interfacetypename": ["Alarm Panel"]}},
            {"WidgetID": 13, "WidgetType": "MultiKPI","Datapoints": {"Interfacetypename": ["Fire Panel"]}},
            {"WidgetID": 14,"WidgetType": "MultiKPI","Datapoints": {"Interfacetypename": ["RTU"]}}];

        getDeviceStatusData({
          UserID: UserID,
          widgets: payload,
          filters: globalFilter,
        })
          .then((res) => {
            if (res && res.Status === "success") {
              setDeviceStatus(res.Data);
            }
          })
          .catch((err) => console.log(err));
      };

    const fetchAlertsData = (dateRangeValue, payload, globalFilter = {}) => {
        const now = new Date();
        // ToDateTime: today at 23:59:59
        const toDate = new Date(
          now.getFullYear(),
          now.getMonth(),
          now.getDate(),
          23,
          59,
          59,
          999
        );
        // FromDateTime: (today - (dateRangeValue - 1)) at 00:00:00
        const fromDate = new Date(toDate);
        fromDate.setDate(
          toDate.getDate() - (dateRangeValue ? dateRangeValue - 1 : 0)
        );
        fromDate.setHours(0, 0, 0, 0);
    
        const formatDate = (date) => {
          const pad = (n) => n.toString().padStart(2, "0");
          return (
            date.getFullYear() +
            "-" +
            pad(date.getMonth() + 1) +
            "-" +
            pad(date.getDate()) +
            " " +
            pad(date.getHours()) +
            ":" +
            pad(date.getMinutes()) +
            ":" +
            pad(date.getSeconds())
          );
        };
    
        getAlertsData({
          UserID: UserID,
          widgets: payload,
          DateRange: dateRangeValue,
          FromDateTime: formatDate(fromDate),
          ToDateTime: formatDate(toDate),
          filters: globalFilter,
        })
          .then((res) => {
            if (res && res.Status === "success") {
              setAlertsData((prev) => ({
                ...prev,
                [dateRangeValue]: res.Data, // Store by DateRange
              }));
            }
          })
          .catch((err) => console.log(err));
      };

    const dashboardAPICalls = () =>{
      fetchDeviceStatusData({ SiteID: [siteId] });
        const dateRanges = [1, 30];
        const alert30DaysPayload = [{"WidgetID": 5,"WidgetType": "BarChart","Datapoints": ["AlertCount","SiteName"]},
        {"WidgetID": 6,"WidgetType": "BarChart","Datapoints": ["AlertCount","AlertType"]},
        {"WidgetID": 7,"WidgetType": "BarChart","Datapoints": ["AlertCount","AlertType"]},
        {"WidgetID": 8,"WidgetType": "DonutChart","Datapoints": ["AlertCount","Severity"]},
        {"WidgetID": 9,"WidgetType": "PieChart","Datapoints": ["AlertCount","AlertStatus"]},
        {"WidgetID": 16, "WidgetType": "PieChart", "Datapoints": ["AlertCount","InterfacetypeName"]}]
        
        const alert1DayPayload = [{"WidgetID": 3,"WidgetType": "SingleKPI","Datapoints": ["AlertCount"]},
        {"WidgetID": 6,"WidgetType": "BarChart","Datapoints": ["AlertCount","Severity"]},
        {"WidgetID": 15, "WidgetType": "MultiKPI", "Datapoints": {"Severity": null,"AlertStatus": null}}];
        
        fetchAlertsData(1, alert1DayPayload, { SiteID: [siteId] });
        fetchAlertsData(30, alert30DaysPayload, { SiteID: [siteId] });
    }

    useEffect(() => {
        dashboardAPICalls();
    }, []);

    useEffect(() => {
      const interval = setInterval(() => {
        dashboardAPICalls();
      }, DASHBOARD_INTERVAL_TIMER); // 10 seconds interval
  
      return () => clearInterval(interval); // Cleanup on unmount
    }, []);

    const handlebackSite = () =>{
         history.push({
            pathname: "/customer-details",
           state : {clientName: clientName, siteId: siteId, SiteName: SiteName, ClientId: ClientId}
        });
    }
    
    return (
      <div>
        <div className="NameHeading1 mt-4 ml-3" style={{ display: 'flex' }}>
          <button className="addCustomer"
            onClick={handlebackSite}>
            <span className="ViewUpdate">
              <img src={LeftArrowWhite} alt="add plus icon" />
            </span>
          </button>
          <p className="config-tool-head textCustomer">Site Name: {SiteName}</p>
        </div>
        <div className="col-lg-12 float-left mt-3">
          <div className='dashboardScroll' style={{ display: "block", height: "calc(100vh - 160px)", overflow: "auto", padding: "0px" }}>
            <AccordionMunu
              SiteName={SiteName}
              siteId={siteId}
              handleModalShow={handleModalShow}
              getcsvFileName={getcsvFileName}
              deviceStatus={deviceStatus}
              alertsData={alertsData}
              isDarkTheme={isDarkTheme}
            />
          </div>
        </div>
      </div>
    )
}

export default DashboardConfigMain